import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContractManagementService } from '../contract-management.service';
import * as InvoiceCycleActions from './invoice-cycle.actions';
import { switchMap, map, catchError, flatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromShared from '../../shared';

@Injectable()
export class InvoiceCycleEffects {
    constructor(
        private actions$: Actions,
        private service: ContractManagementService
    ) {}

    getInvoiceCycle$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InvoiceCycleActions.getInvoiceCycle),
            switchMap(() =>
                this.service.getInvoiceCycle().pipe(
                    map(resp =>
                        InvoiceCycleActions.loadInvoiceCycles({
                            invoiceCycles: resp
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
